import { useCallback } from "react";

import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import useUiuxStore from "src/store/useUiuxStore";

import { useTQC1050_R01Store } from "./Store_TQC1050_R01";

interface EmployeeSearchResult {
	empNo?: string;
	empNm?: string;
}

/**
 * 검사자 / 검사구분 / 승인자 입력 영역.
 *
 * <p>입력된 검사자와 승인자는 저장 시 수정된 행의 검사결과 헤더에 반영한다.
 */
export const Info_TQC1050_R01 = () => {
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
		TQC1050_R01Info,
		setTQC1050_R01Info,
	} = useTQC1050_R01Store();

	const openEmployeeModal = useCallback(
		(field: "inspector" | "approvor") => {
			const isInspector = field === "inspector";
			setCodeSearchModalProps({
				category: isInspector ? "검사자" : "승인자",
				search: isInspector ? TQC1050_R01Info.inspectorEmp : TQC1050_R01Info.approvorEmpno,
				formName: "TQC1050_R01",
				isInfo: true,
				handleFoucsId: isInspector ? "tqc1050_inspectorEmp" : "tqc1050_approvorEmpno",
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () => {
					setTQC1050_R01Info(
						isInspector
							? { inspectorEmp: "", inspectorEmpNm: "" }
							: { approvorEmpno: "", approvorEmpNm: "" },
					);
				},
				onConfirm: (data: EmployeeSearchResult) => {
					setTQC1050_R01Info(
						isInspector
							? { inspectorEmp: data.empNo || "", inspectorEmpNm: data.empNm || "" }
							: { approvorEmpno: data.empNo || "", approvorEmpNm: data.empNm || "" },
					);
				},
			});
		},
		[setCodeSearchModalProps, setTQC1050_R01Info, TQC1050_R01Info],
	);

	return (
		<div className="flex items-center flex-wrap px-[12px] pt-[8px]">
			<CodeForm
				label="검사자"
				name="inspectorEmp"
				value={TQC1050_R01Info.inspectorEmp}
				custNmValue={TQC1050_R01Info.inspectorEmpNm}
				handleFoucsId="tqc1050_inspectorEmp"
				handleChange={(e) => setTQC1050_R01Info({ inspectorEmp: e.target.value })}
				onDoubleClick={() => openEmployeeModal("inspector")}
			/>

			<InputForm
				title="검사구분"
				name="inspectType"
				value="수입검사"
				editable={false}
			/>

			<CodeForm
				label="승인자"
				name="approvorEmpno"
				value={TQC1050_R01Info.approvorEmpno}
				custNmValue={TQC1050_R01Info.approvorEmpNm}
				handleFoucsId="tqc1050_approvorEmpno"
				handleChange={(e) => setTQC1050_R01Info({ approvorEmpno: e.target.value })}
				onDoubleClick={() => openEmployeeModal("approvor")}
			/>
		</div>
	);
};
